import getStore from 'services/getStore';
import { setActiveTopicAction } from 'store/next';

export default id => {
  getStore().dispatch(setActiveTopicAction(id));
};
